import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const $webtitle = '嘉诚海外移动端'
const $keyword = '移民,投资移民,移民公司,移民中介,美国投资移民,加拿大移民,欧洲移民,欧洲投资移民,嘉诚海外'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/homeindex',
    component: Home,
    children: [
      {
        path: 'homeindex',
        name: 'HomeIndex',
        component: () => import(/* webpackChunkName: "about" */ '../views/HomeIndex'),
        meta: {
          title: $webtitle + '-加拿大移民公司|欧洲投资移民公司|三十年口碑|成功的见证',
          keyword: $keyword
        }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        meta: {
          title: $webtitle + '-集团介绍',
          keyword: $keyword
        }
      },

      {
        path: 'contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
        meta: {
          title: $webtitle + '-联系我们',
          keyword: $keyword
        }
      },
    ],
    meta: {
      title: $webtitle + '-加拿大移民公司|欧洲投资移民公司|三十年口碑|成功的见证',
      keyword: $keyword
    }
  },


  {
    path: '/usa',
    name: 'Usa',
    redirect: '/usa/usaindex',
    component: () => import(/* webpackChunkName: "about" */ '../views/Usa.vue'),
    children: [
      {
        path: 'usaindex',
        name: 'UsaIndex',
        component: () => import(/* webpackChunkName: "about" */ '../views/UsaIndex'),
        meta: {
          title: $webtitle + '-美国移民',
          keyword: $keyword
        }
      },
      {
        path: 'l1',
        name: 'UsaL1',
        component: () => import(/* webpackChunkName: "about" */ '../views/UsaL1.vue'),
        meta: {
          title: $webtitle + '-美国L1签证',
          keyword: $keyword
        }
      },
      {
        path: 'eb5',
        name: 'UsaEb5',
        component: () => import(/* webpackChunkName: "about" */ '../views/UsaEb5.vue'),
        meta: {
          title: $webtitle + '-美国EB-5投资移民',
          keyword: $keyword
        }
      },
    ],
    meta: {
      title: $webtitle + '-美国移民',
      keyword: $keyword
    }
  },

  {
    path: '/ca',
    name: 'Ca',
    component: () => import(/* webpackChunkName: "about" */ '../views/Ca.vue'),
    redirect: '/ca/caindex',
    children: [
      {
        path: 'caindex',
        name: 'CaIndex',
        component: () => import(/* webpackChunkName: "about" */ '../views/CaIndex.vue'),
        meta: {
          title: $webtitle + '-加拿大移民',
          keyword: $keyword
        }
      },
      {
        path: 'cazigu',
        name: 'CaZigu',
        component: () => import(/* webpackChunkName: "about" */ '../views/CaZigu.vue'),
        meta: {
          title: $webtitle + '-加拿大自雇移民',
          keyword: $keyword
        }
      },
      {
        path: '/ca/cakui',
        name: 'CaKui',
        component: () => import(/* webpackChunkName: "about" */ '../views/CaKui.vue'),
        meta: {
          title: $webtitle + '-加拿大魁省移民',
          keyword: $keyword
        }
      },

      {
        path: '/ca/cabc',
        name: 'CaBc',
        component: () => import( '../views/CaBc.vue'),
        meta: {
          title: $webtitle + '-加拿大BC移民',
          keyword: $keyword
        }
      },

      {
        path: '/ca/casa',
        name: 'CaSa',
        component: () => import( '../views/CaSa.vue'),
        meta: {
          title: $webtitle + '-加拿大萨省移民',
          keyword: $keyword
        }
      },

      {
        path: '/ca/caman',
        name: 'CaMan',
        component: () => import( '../views/CaMan.vue'),
        meta: {
          title: $webtitle + '-加拿大曼省留学移民',
          keyword: $keyword
        }
      },

      {
        path: '/ca/caguzhu',
        name: 'CaGuZhu',
        component: () => import( '../views/CaGuzhu.vue'),
        meta: {
          title: $webtitle + '-加拿大雇主担保移民',
          keyword: $keyword
        }
      },

      {
        path: '/ca/casuv',
        name: 'CaSuv',
        component: () => import( '../views/CaSuv.vue'),
        meta: {
          title: $webtitle + '-加拿大联邦创业移民(SUV)',
          keyword: $keyword
        }
      },
    ],
    meta: {
      title: $webtitle + '-加拿大移民',
      keyword: $keyword
    }
  },

  {
    path: '/ptg',
    name: 'Ptg',
    component: () => import( '../views/Ptg.vue'),
    meta: {
      title: $webtitle + '-葡萄牙35万欧基金移民',
      keyword: $keyword
    }
  },

  {
    path: '/ie',
    name: 'Ie',
    component: () => import( '../views/Ie.vue'),
    meta: {
      title: $webtitle + '-爱尔兰移民',
      keyword: $keyword
    }
  },

  {
    path: '/cy',
    name: 'Cy',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cy.vue'),
    meta: {
      title: $webtitle + '-塞浦路斯护照移民',
      keyword: $keyword
    }
  },
  {
    path: '/hk',
    name: 'Hk',
    component: () => import(/* webpackChunkName: "about" */ '../views/Hk.vue'),
    meta: {
      title: $webtitle + '-香港专才移民',
      keyword: $keyword
    }
  },
  {
    path: '/jp',
    name: 'Jp',
    component: () => import(/* webpackChunkName: "about" */ '../views/Jp.vue'),
    meta: {
      title: $webtitle + '-日本投资移民',
      keyword: $keyword
    }
  },
  {
    path: '/gr',
    name: 'Gr',
    component: () => import(/* webpackChunkName: "about" */ '../views/Gr.vue'),
    meta: {
      title: $webtitle + '-希腊购房移民',
      keyword: $keyword
    }
  },

]

const router = new VueRouter({
  routes
})

export default router
